import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstanceJson from "../../../AxiosInstance/axiosInstanceJson";
import axiosInstance from "../../../AxiosInstance/axiosInstance";

export const getAllUsers = createAsyncThunk(
  "communityMember/getCommunityMember",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.get(
        `/v1/admin/communityMember/get-allUsers`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createCommityMember = createAsyncThunk(
  "communityMember/createCommunityMember",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.post(
        `/v1/admin/communityMember/create-commityMember`,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getCommityMember = createAsyncThunk(
  "communityMember/getAll",
  async (
    {
      categoryId,
      status = "all",
      search = "",
      page = 1,
      limit = 10,
      startDate,
      endDate,
      paginate,
    },
    thunkAPI
  ) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/admin/communityMember/get-commityMember`,
        {
          params: {
            categoryId,
            status,
            search,
            page: Number(page),
            limit: Number(limit),
            startDate: startDate || undefined,
            endDate: endDate || undefined,
            paginate: paginate === "true",
          },
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error occurred");
    }
  }
);

export const deleteCommityMember = createAsyncThunk(
  "commityMember/delete",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstance.delete(
        `/v1/admin/communityMember/delete-commityMember/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const undoDeleteCommityMember = createAsyncThunk(
  "communityMember/undoDelete",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.put(
        `/v1/admin/communityMember/undodelete-commityMember/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getCommityMemberByIdData = createAsyncThunk(
  "communityMember/getById",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/admin/communityMember/get_singlecommityMember/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const updateCommityMember = createAsyncThunk(
  "communityMember/update",
  async ({ _id, formData }, thunkAPI) => {
    try {
      const response = await axiosInstanceJson.put(
        `/v1/admin/communityMember/update_commityMember/${_id}`,
        formData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
